import { fg } from '@atlaskit/platform-feature-flags';

export default {
	get(): boolean {
		return fg('icp_work_people_reordering');
	},
};
